import { apiUrl, responseError } from "./api";
import { clearActiveCapture, type ActiveCaptureMetadata } from "./storage";
import type { RecordingBuffer } from "../services";

/**
 * Permanently releases an unfinished capture after the user has explicitly
 * chosen to discard it. Server cleanup runs first; the local recovery pointer
 * remains intact if either server or device cleanup fails.
 */
export async function discardUnfinishedCapture(
  metadata: ActiveCaptureMetadata,
  buffer: RecordingBuffer
): Promise<void> {
  if (metadata.matterId) {
    const response = await fetch(
      apiUrl(`/api/matters/${encodeURIComponent(metadata.matterId)}`),
      { method: "DELETE", credentials: "same-origin" }
    );
    if (!response.ok && response.status !== 404 && response.status !== 410) {
      throw await responseError(
        response,
        "The unfinished transcript could not be discarded."
      );
    }
  }

  await Promise.all([
    buffer.clearRecording(metadata.recordingId),
    buffer.clearRecording(`analysis:${metadata.recordingId}`)
  ]);
  clearActiveCapture();
}
